module.exports = __webpack_public_path__ + "static/img/4.9006d1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-pt/4.jpg
// module id = ZChH
// module chunks = 1